import React, { useEffect, useState } from "react";
import Button from "../../common/button/button";
import Row from "../../common/layout/row";
import ContentCardHeader from "../../common/template/contentCardHeader";
import Select from "../../common/form/select";
import { LabelSelectUcIconeGestor } from "../../common/form/LabelSelectUcIconeGestor";
import Grid from "../../common/layout/grid";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getListaFaturasAdm, setFiltro } from "../faturaActions";
import { ModalFiltrosFaturasClienteAgua } from "./ModalFiltrosFaturasClienteAgua";

function FiltrosFaturasClienteAguaComponent(props) {
    useEffect(() => {
        console.log(props.filtro);
        if (props.filtro.id_cliente && !props.listaCliente.find((cli) => cli.id == props.filtro.id_cliente)) {
            props.setFiltro({
                ...props.filtro,
                id_cliente: null,
                id_empenho: null,
                unidades_consumidoras: [],
            });
        }
    }, []);

    const [modalFiltrosAberto, setModalFiltrosAberto] = useState(false);

    return (
        <>
            <ModalFiltrosFaturasClienteAgua visible={modalFiltrosAberto} handleClose={() => setModalFiltrosAberto(false)} {...props} />
            <ContentCardHeader>
                <Row style={{ paddingBlock: 15 }}>
                    {!props.usuarioLogadoAcessoCliente ? (
                        <Select
                            readOnly={props.aguardando}
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 12 6 6"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_empenho: null,
                                    unidades_consumidoras: [],
                                });
                            }}
                        />
                    ) : null}
                    <Select
                        readOnly={props.aguardando}
                        name="ano"
                        options={Array.from({ length: 20 }, (v, i) => ({
                            id: new Date().getFullYear() - 5 + i,
                            valor: new Date().getFullYear() - 5 + i,
                        }))}
                        label="Ano"
                        cols={props.usuarioLogadoAcessoCliente ? "12 6 3 3" : "12 6 2 2"}
                        placeholder="Selecione o ano"
                        value={props.filtro.ano}
                        isClearable={false}
                        onChange={(value) => {
                            props.setFiltro({
                                ...props.filtro,
                                ano: value,
                            });
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="mes"
                        options={props.listaMeses}
                        label="Mês"
                        cols={props.usuarioLogadoAcessoCliente ? "12 6 3 3" : "12 6 2 2"}
                        placeholder="Selecione o mês"
                        value={props.filtro.mes}
                        onChange={(value) => {
                            props.setFiltro({
                                ...props.filtro,
                                mes: value,
                            });
                        }}
                    />{" "}
                    <Select
                        readOnly={props.aguardando}
                        options={[
                            { id: 1, valor: "Todas" },
                            { id: 2, valor: "Download Realizado" },
                            { id: 3, valor: "Download Pendente" },
                        ]}
                        label="Situação do Download"
                        cols={props.usuarioLogadoAcessoCliente ? "12 6 3 3" : "12 6 2 2"}
                        placeholder="Selecione a situação do download"
                        value={props.filtroState.situacaoDownload}
                        isClearable={false}
                        isSearchable={false}
                        onChange={(value) => {
                            props.setState({
                                ...props.filtroState,
                                situacaoDownload: value,
                            });
                        }}
                    />
                    {!props.usuarioLogadoAcessoCliente ? (
                        <>
                            <Select
                                readOnly={props.aguardando}
                                options={props.listaUnidadeConsumidora}
                                label={
                                    <LabelSelectUcIconeGestor
                                        isMulti={true}
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                        setExibirModal={(ucFiltro) =>
                                            props.setState({
                                                ...props.filtroState,
                                                exibirModalGestorConcessionaria: true,
                                                itemSelecionado: ucFiltro,
                                            })
                                        }
                                    />
                                }
                                cols={"12 12 10 10"}
                                placeholder="Selecione as UCs"
                                isMulti={true}
                                value={props.filtro.unidades_consumidoras}
                                onChange={(ucsSelecionadas) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        unidades_consumidoras: [...ucsSelecionadas],
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                name="id_concessionaria"
                                options={props.listaConcessionaria}
                                label="Concessionária"
                                cols="12 12 2 2"
                                placeholder="Selecione a concessionaria"
                                value={props.filtro.id_concessionaria}
                                onChange={(id_concessionaria) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_concessionaria,
                                    });
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <Select
                                readOnly={props.aguardando}
                                name="id_concessionaria"
                                options={props.listaConcessionaria}
                                label="Concessionária"
                                cols="12 6 3 3"
                                placeholder="Selecione a concessionaria"
                                value={props.filtro.id_concessionaria}
                                onChange={(id_concessionaria) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_concessionaria,
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                options={props.listaUnidadeConsumidora}
                                label="Unidades Consumidoras"
                                cols={"12 12 12 12"}
                                placeholder="Selecione as UCs"
                                isMulti={true}
                                value={props.filtro.unidades_consumidoras}
                                onChange={(ucsSelecionadas) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        unidades_consumidoras: [...ucsSelecionadas],
                                    });
                                }}
                            />
                        </>
                    )}
                </Row>
                <Row style={{ padding: 7 }}>
                    <Grid cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                        <Button
                            title="Filtros"
                            disabled={props.aguardando}
                            icon="fas fa-filter"
                            text="Filtros"
                            type={"light"}
                            solid={true}
                            forceBoxShadow={true}
                            event={() => setModalFiltrosAberto(true)}
                        />
                    </Grid>
                    {(props.buttons || []).map((botao, i) => (
                        <Grid key={i} cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                            {botao}
                        </Grid>
                    ))}
                </Row>
            </ContentCardHeader>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        listaMeses: state.fatura.listaMeses,
        listaCliente: state.fatura.listaClienteAgua,
        listaConcessionaria: state.fatura.listaConcessionariaAgua,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaFaturasAdm,
        },
        dispatch
    );
const FiltrosFaturasClienteAgua = connect(mapStateToProps, mapDispatchToProps)(FiltrosFaturasClienteAguaComponent);
export { FiltrosFaturasClienteAgua };
